const CHECKS = [["r", "R"], ["be", "BE"], ["htf", "4H"], ["flow", "FLOW"], ["structure", "STRUCT"], ["risk", "RISK"], ["news", "NEWS"], ["adds", "ADDS"]];
const rr = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${v.toFixed(2)}R`);

export const MbtAddGate = ({ g }) => {
  if (!g) return null;
  const ok = g.eligible;
  const done = (g.adds ?? 0) >= (g.max_adds ?? 1);
  const tone = done ? "var(--r2-cyan)" : ok ? "var(--r2-emerald)" : "var(--r2-amber)";
  const label = done ? `SCALED IN ${g.adds}/${g.max_adds}` : ok ? "ADD ARMED" : "ADD WAITING";
  const mode = g.trend_mode ? `TREND PYRAMID · ${g.qty ?? 1} lot${(g.qty ?? 1) > 1 ? "s" : ""} · 4H ${(g.htf || "—").toUpperCase()} / 1H ${(g.ltf || "—").toUpperCase()}` : "SCALE-OUT LADDER";
  return (
    <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 border-t border-[var(--r2-border)] pt-1" data-testid="mbt2-add-gate">
      <span className="text-[7px] font-bold tracking-[0.18em]" style={{ color: tone }} data-testid="mbt2-add-gate-status">{label}</span>
      <span className="text-[7px] font-bold tracking-[0.14em] text-[var(--r2-text2)]" data-testid="mbt2-add-gate-mode">{mode}</span>
      <span className="r2-num text-[7.5px] text-[var(--r2-text2)]" data-testid="mbt2-add-gate-r">{rr(g.current_r)} · {g.trend_mode ? `next add +${g.next_add_r ?? g.min_r ?? 1}R` : `window +${g.min_r ?? 1}R${g.max_r ? `..+${g.max_r}R` : ""}`} · lock {rr(g.locked_r)}</span>
      <div className="flex items-center gap-1">
        {CHECKS.map(([k, lbl]) => {
          const v = g.checks?.[k];
          const c = v == null ? "var(--r2-text2)" : v ? "var(--r2-emerald)" : "var(--r2-red)";
          return (
            <span key={k} className="rounded-sm border px-1 py-[1px] text-[6.5px] font-bold tracking-[0.1em]" style={{ color: c, borderColor: c }} data-testid={`mbt2-add-check-${k}`}>
              {v == null ? "·" : v ? "✓" : "✗"} {lbl}
            </span>
          );
        })}
      </div>
      {!ok && !done && g.block && <span className="text-[7px] text-[var(--r2-amber)]" data-testid="mbt2-add-gate-block">waiting: {g.block}</span>}
      {g.flow && <span className="text-[7px] text-[var(--r2-text2)]" data-testid="mbt2-add-gate-flow">flow: {g.flow}</span>}
      {g.risk?.stale && <span className="text-[7px] text-[var(--r2-text2)]" data-testid="mbt2-add-gate-risk-stale">risk verdict {g.risk.verdict} stale ({Math.round((g.risk.age_sec ?? 0) / 60)}m) — ignored</span>}
    </div>
  );
};
